module.exports = __webpack_public_path__ + "media/newstyle/images/stars_5-red-0921bbb0054e1776f6198bdc45b61bc9.svg";